"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTracking = exports.useAutoPageTracking = exports.isNavigationKeyPress = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useDebounce = require("use-debounce");
var _trackingContextProvider = require("../contextProviders/trackingContextProvider");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isNavigationKeyPress = event => {
  const {
    code,
    keyCode
  } = event;
  const navigationCodes = ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Tab'];
  const navigationKeyCodes = [37, 38, 39, 40, 9];
  return code && navigationCodes.indexOf(code) !== -1 || keyCode && navigationKeyCodes.indexOf(keyCode) !== -1;
};

/*
  Examples of how to use this hook to track clicking a button.
  Call it as a property of the element itself

  const myReactElementRef = useRef(null);

  <button
    type="button"
    id="myTrackedButton"
    ref={ myReactElementRef }
    { ...useTracking({ elementRef: myReactElementRef }) }
  >
    This is the button label
  </button>

  Or attach it programmatically

  const myReactElementRef = useRef(null);
  const myReactElementTracking = useTracking({ elementRef: myReactElementRef });

  By default, it will track click events.
  You can also pass any other browser events you want to track as a custom array.
  You can also pass custom data as an optional additional payload.

  const myReactElementTracking = useTracking(
    {
      elementRef: myReactElementRef,
      trackingProps: {
        // A selection of properties from the component
      },
      customTrackingData: {
        'myDogsNames': ['Rocket', 'Pippa']
      },
      customTrackingEvents: ['mouseover']
    }
  );
 */
exports.isNavigationKeyPress = isNavigationKeyPress;
const defaultEventsByTagAndType = {
  input: {
    password: ['focus', 'blur'],
    // Do not track values
    default: ['change', 'input', 'focus', 'blur']
  },
  select: ['change', 'focus', 'blur', 'select'],
  textarea: ['change', 'input', 'focus', 'blur'],
  a: ['click', 'focus', 'blur'],
  button: ['click', 'focus', 'blur'],
  default: ['click', 'scroll']
};
const useTracking = _ref => {
  let {
    elementRef,
    trackingProps,
    customTrackingData,
    customTrackingEvents
  } = _ref;
  const [domElement, setDomElement] = (0, _react.useState)(null);
  const trackingFunction = (0, _react.useContext)(_trackingContextProvider.TrackingContext);
  const eventsToTrack = (0, _react.useCallback)(domNode => {
    const {
      tagName,
      type
    } = domNode;
    const defaultEvents = defaultEventsByTagAndType[tagName.toLowerCase()];
    if (customTrackingEvents) {
      return customTrackingEvents;
    }
    if (Array.isArray(defaultEvents)) {
      return defaultEvents;
    }

    // Assume for now that it is a keyed object
    if (typeof defaultEvents !== 'undefined') {
      if (defaultEvents[type]) {
        return defaultEvents[type];
      }
      return defaultEvents.default || defaultEventsByTagAndType.default;
    }
    return defaultEventsByTagAndType.default;
  }, [customTrackingEvents]);
  const onTrackingEvent = (0, _useDebounce.useDebouncedCallback)(event => {
    const {
      type: eventType
    } = event;
    const {
      type: inputType,
      tagName,
      classList,
      innerText,
      id,
      value,
      labels
    } = domElement;
    const trackingPayload = _objectSpread(_objectSpread({
      label: labels && labels[0] ? labels[0].innerText : innerText,
      tagName,
      classList: classList.value,
      innerText,
      inputType,
      value,
      id,
      eventType
    }, customTrackingData), trackingProps);
    if (typeof trackingFunction === 'function') {
      // eslint-disable-next-line no-console
      trackingFunction(eventType, trackingPayload);
    }
  }, 500, {
    maxWait: 2000
  });
  (0, _react.useEffect)(() => {
    const domNode = elementRef && elementRef.current || null;
    if (domNode) {
      setDomElement(domNode);
      eventsToTrack(domNode).forEach(eventType => {
        domNode.addEventListener(eventType, onTrackingEvent);
      });
    }
  }, [eventsToTrack, elementRef, onTrackingEvent]);
  return {};
};
exports.useTracking = useTracking;
useTracking.propTypes = {
  elementRef: _propTypes.default.element.isRequired,
  trackingProps: _propTypes.default.shape({
    label: _propTypes.default.shape({
      label: _propTypes.default.string,
      labelId: _propTypes.default.string,
      labelTooltip: _propTypes.default.string,
      hideLabel: _propTypes.default.bool
    }),
    field: _propTypes.default.shape({
      // eslint-disable-next-line react/forbid-prop-types
      formContext: _propTypes.default.any,
      fieldElement: _propTypes.default.node,
      inputType: _propTypes.default.string,
      defaultValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
      showSpinner: _propTypes.default.bool,
      name: _propTypes.default.string,
      id: _propTypes.default.string
    })
  }),
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.object,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string)
};
useTracking.defaultProps = {
  customData: null,
  customTrackingEvents: ['click']
};

/*
  A hook for adding a wide range of tracking events to an entire page
  based on the types of elements and possible interactions.
  Note: This may degrade performance so use with caution
 */
const useAutoPageTracking = _ref2 => {
  let {
    customData,
    trackingFunction = () => {}
  } = _ref2;
  const elementTagsToTrack = ['div', 'button', 'input', 'a', 'main'];
  const elementAttributesToTrack = ['[role="menu"]', '[role="menuitem"]'];
  const eventsToTrack = (0, _react.useMemo)(() => ['click', 'scroll', 'input', 'keyup'], []);
  const targetHasTrackingAttribute = target => {
    let attrFound = false;
    elementAttributesToTrack.forEach(attr => {
      if (target.hasAttribute(attr)) {
        attrFound = true;
      }
    });
    return attrFound;
  };
  const onTrackingEvent = (0, _useDebounce.useDebouncedCallback)(event => {
    const {
      target,
      type: eventType,
      code,
      keyCode
    } = event;
    const {
      tagName,
      classList,
      innerText,
      id,
      value,
      labels
    } = target;
    const keyboardNavigationEvent = isNavigationKeyPress(event);
    if (eventType === 'keyup' && !keyboardNavigationEvent || tagName === 'INPUT' && target.type.toLowerCase() === 'password') {
      return event;
    }
    if (elementTagsToTrack.indexOf(tagName.toLowerCase()) !== -1 || targetHasTrackingAttribute(target)) {
      // Send details about the element to the tracking provider
      const trackingPayload = {
        label: labels && labels[0] ? labels[0].innerText : innerText,
        tagName,
        classList: classList.value,
        innerText,
        value,
        id,
        customData,
        eventType
      };
      if (keyboardNavigationEvent) {
        trackingPayload.navigationKey = {
          code,
          keyCode
        };
      }
      if (typeof trackingFunction === 'function') {
        // eslint-disable-next-line no-console
        trackingFunction(eventType, trackingPayload);
      }
    }
    return event;
  }, 500, {
    maxWait: 2000
  });
  (0, _react.useEffect)(() => {
    eventsToTrack.forEach(eventType => {
      document.body.addEventListener(eventType, onTrackingEvent);
    });
    document.addEventListener('scroll', trackingFunction('scroll', {
      tagName: 'body',
      eventType: 'scroll'
    }));
  }, [eventsToTrack, onTrackingEvent, trackingFunction]);
};
exports.useAutoPageTracking = useAutoPageTracking;
useAutoPageTracking.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  customData: _propTypes.default.object,
  trackingFunction: _propTypes.default.func
};
useAutoPageTracking.defaultProps = {
  customData: null
};